var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaximize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "188.274 181.574 18 18",
    width: 18,
    height: 18,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M 188.274 181.574 L 194.274 181.574 L 194.274 183.574 L 190.274 183.574 L 190.274 187.574 L 188.274 187.574 L 188.274 181.574 Z M 188.274 199.574 L 194.274 199.574 L 194.274 197.574 L 190.274 197.574 L 190.274 193.574 L 188.274 193.574 L 188.274 199.574 Z M 200.274 199.574 L 206.274 199.574 L 206.274 193.574 L 204.274 193.574 L 204.274 197.574 L 200.274 197.574 L 200.274 199.574 Z M 206.274 181.574 L 200.274 181.574 L 200.274 183.574 L 204.274 183.574 L 204.274 187.574 L 206.274 187.574 L 206.274 181.574 Z",
    transform: "matrix(1, 0, 0, 1, 0, 3.552713678800501e-15)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaximize);
export default __webpack_public_path__ + "static/media/maximize.3725cc5f.svg";
export { ForwardRef as ReactComponent };